// @ts-check

import { COLLISION_RANKING_TIERS, MARKER_ANCHOR, MapView, Mappedin, MappedinNode, getVenue } from "@mappedin/mappedin-js";

import * as ActivityTypeHelper from '../../../utils/activityTypeHelper';
import * as AssetHelper from '../../../utils/assetHelper';
import React from "react";
import * as ReactDOMServer from 'react-dom/server';
import Label from "../../../../../infrastructure/js/components/Label/label";
import { createLabelHelper } from "../../../../../infrastructure/js/utils/labelHelper";
import Link from "../../Common/Layout/Link/link";
import { navigationStates } from "../../../enums/navigationStates";



/**
 * @typedef {import("../../../actions/LiveMap/liveMapPageTypes").LocationTooltipState} LocationTooltipState
 * @typedef {import("@mappedin/mappedin-js/renderer/internal").SmartTooltip} SmartTooltip
 * 
 */



let assetTypeLabels = createLabelHelper('');


export class MapLocationTooltipLogic {


  /**
   * @param {any | undefined} sData
   * @param {Mappedin} venue
   * @param {MapView} mapView
   * @param {any | undefined} currentEntrance
   * @param {(mapView: MapView) => void} recolorMap
   */
  static process = (sData, venue, mapView, currentEntrance, recolorMap) => {

    let sLocationDetails = sData.get('locationDetails');

    /** @type {LocationTooltipState} */
    let sLocationTooltipState = sData.get('locationTooltipState');


    // if (sLocationDetails === null) {
    //   mapView.removeAllTooltips();
    //   recolorMap(venue, mapView);
    //   return;
    // }

    if (sLocationTooltipState === "HIDDEN") {
      mapView.removeAllTooltips();
      recolorMap(mapView);
      return;
    }


    /** @type {MappedinNode | null} */
    let entrance = currentEntrance.current;
    if (!entrance) {
      return;
    }


    let parentPolygon = entrance.polygon;



    // Highlight current polygon
    recolorMap(mapView);
    // mapView.setPolygonColor(parentPolygon, "#0000FF");
    mapView.setPolygonColor(parentPolygon, "#6BC0F4");


    mapView.removeAllTooltips();


    /** @type {SmartTooltip | null} */
    let tooltipObject = null; // Could be used to remove the specific tooltip later.

    if (sLocationTooltipState === "LOADING") {
      let tooltipHtml = getLocationTooltipLoadingHtml(sLocationDetails);
      tooltipObject = mapView.createTooltip(entrance, tooltipHtml);
    }

    if (sLocationTooltipState === "VISIBLE") {
      let tooltipHtml = getLocationTooltipHtml(sLocationDetails);
      tooltipObject = mapView.createTooltip(entrance, tooltipHtml);

      // console.log('parentPolygon ===> ', parentPolygon);
      // console.log('parentPolygon.entrances ===> ', parentPolygon.entrances);
      if (parentPolygon.label) {
        // console.log('parentPolygon.label ===> ', parentPolygon.label);
        parentPolygon.label.visible = true;
      }


      // console.log('entrance ===> ', entrance);
      // console.log('entrance.locations ===> ', entrance.locations);

      // let primaryLocation = mapView.getPrimaryLocationForPolygon(parentPolygon);
      // console.log('primaryLocation ===> ', primaryLocation);




      // let iconSvg = `<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" width="512" height="512" viewBox="0 0 24 24"><path d="M15.5,6c-1.378,0-2.5,1.122-2.5,2.5s1.122,2.5,2.5,2.5,2.5-1.122,2.5-2.5-1.122-2.5-2.5-2.5Zm0,4c-.827,0-1.5-.673-1.5-1.5s.673-1.5,1.5-1.5,1.5,.673,1.5,1.5-.673,1.5-1.5,1.5ZM24,2.5c0-1.378-1.122-2.5-2.514-2.5-4.942,.141-9.444,2.552-13.111,7.001-1.586,.019-3.168,.404-4.585,1.115-2.302,1.155-3.79,3.661-3.79,6.384v.5H5c1.068,0,2.073,.416,2.829,1.171,.755,.756,1.171,1.76,1.171,2.829v5h.5c2.723,0,5.229-1.487,6.384-3.789,.712-1.417,1.096-3,1.115-4.586,4.448-3.667,6.86-8.17,7.001-13.125ZM4.238,9.01c1.034-.519,2.165-.845,3.317-.961-.098,.132-.196,.265-.293,.4-1.553,2.167-2.712,4.684-3.092,5.551H1.019c.166-2.15,1.393-4.074,3.219-4.99Zm10.752,10.752c-.917,1.826-2.84,3.053-4.99,3.219v-3.151c.868-.38,3.384-1.539,5.552-3.092,.135-.097,.268-.194,.4-.292-.116,1.152-.442,2.283-.961,3.317Zm-.021-3.837c-1.803,1.292-3.914,2.325-4.976,2.811-.064-1.236-.576-2.389-1.457-3.271-.882-.882-2.035-1.393-3.271-1.457,.486-1.062,1.519-3.173,2.811-4.976C10.629,5.469,15.033,1.184,21.5,1c.827,0,1.5,.673,1.5,1.486-.184,6.481-4.469,10.885-8.031,13.439ZM1.732,18.732c-.85,.849-1.419,3.881-1.524,4.48l-.124,.703,.703-.124c.599-.105,3.631-.674,4.48-1.524,.472-.472,.732-1.1,.732-1.768s-.26-1.296-.732-1.768c-.943-.944-2.592-.944-3.535,0Zm2.828,2.828c-.386,.386-1.934,.831-3.227,1.106,.275-1.293,.72-2.841,1.106-3.227,.283-.283,.66-.439,1.061-.439s.777,.156,1.061,.439,.439,.66,.439,1.061-.156,.777-.439,1.061Z"/></svg>`;
      // mapView.FloatingLabels.add(parentPolygon, "Label", {
      //   appearance: {
      //     marker: {
      //       icon: iconSvg,
      //       iconSize: 32,
      //       backgroundColor: {
      //         active: "transparent",
      //         // active: "white",
      //         inactive: "transparent"
      //       },
      //       foregroundColor: {
      //         // active: "blue",
      //         active: "transparent",
      //         inactive: "transparent"
      //       },
      //     },
      //     text: {
      //       size: 24,
      //       lineHeight: 24,
      //       // backgroundColor: "#000000",
      //       // foregroundColor: "#FFFFFF",
      //       backgroundColor: "aqua",
      //       foregroundColor: "yellow",
      //     }
      //   }
      // });



      // mapView.Camera.focusOn({
      //   polygons: [parentPolygon]
      // }, {
      //   duration: 2000
      // });



      // const startLocation = venue.locations[0];
      // mapView.Journey.draw(
      //   startLocation.directionsTo(
      //     // venue.locations[20]

      //     // @ts-ignore
      //     venue.locations.find((l) => l.name === "747-8 SMALL PARTS")
      //   )
      // );
      // mapView.StackedMaps.enable({
      //   verticalDistanceBetweenMaps: 125
      // });



      // tooltipObject = mapView.createCustomTooltip(entrance, tooltipHtml, '.stationTooltip', {});


      // mapView.Markers.add(entrance, `<div class="ZupaMarker">Marker => ${sLocationDetails.m_name}</div>`, {
      //   // anchor: MARKER_ANCHOR.BOTTOM,
      //   // rank: COLLISION_RANKING_TIERS.MEDIUM,
      //   // interactive: false
      //   anchor: MARKER_ANCHOR.RIGHT,
      //   rank: COLLISION_RANKING_TIERS.ALWAYS_VISIBLE,
      //   // rank: COLLISION_RANKING_TIERS.HIGH,
      //   // rank: COLLISION_RANKING_TIERS.MEDIUM,
      //   // rank: COLLISION_RANKING_TIERS.OPTIONAL_MAXIMUM,
      //   // rank: COLLISION_RANKING_TIERS.OPTIONAL_MINIMUM,
      //   interactive: true
      // });

      // mapView.Markers.add(entrance, tooltipHtml, {
      //   // anchor: MARKER_ANCHOR.BOTTOM,
      //   // rank: COLLISION_RANKING_TIERS.MEDIUM,
      //   // interactive: false
      //   anchor: MARKER_ANCHOR.TOP,
      //   rank: COLLISION_RANKING_TIERS.ALWAYS_VISIBLE,
      //   interactive: true
      // });



    }


  }



}




////////////////////////////////////////
// Helper functions.
//

/**
 * @param {any} sLocationDetails
 */
let getLocationTooltipLoadingHtml = (sLocationDetails) => {
  return `<span class="messageTooltip"> LOADING... </span>`;
}

/**
 * @param {any} sLocationDetails
 */
let getLocationTooltipErrorHtml = (sLocationDetails) => {
  return `<span class="messageTooltip"> No data </span>`;
}



/**
 * @param {any} sLocationDetails
 */
let getLocationTooltipHtml = (sLocationDetails) => {

  if (sLocationDetails === null) {
    return getLocationTooltipErrorHtml(sLocationDetails);
  }


  // console.log('xxxxxxxxxxxxx TOOLTIP ===> sLocationDetails ===> ', sLocationDetails);

  let name = sLocationDetails.name;

  let numberOfAsstes = sLocationDetails.numberOfAsstes;
  let numberOfResources = sLocationDetails.numberOfResources;
  let numberOfWorkOrders = sLocationDetails.numberOfWorkOrders;





  let tooltipBodyContent = ``;
  tooltipBodyContent += createDataLine('Assets', numberOfAsstes, 'pl-assets');
  tooltipBodyContent += createDataLine('Resources', numberOfResources, 'pl-resources');
  tooltipBodyContent += createDataLine('Work Orders', numberOfWorkOrders, 'pl-header-icon-work_order');

  let headerContentHtml = ReactDOMServer.renderToString(getHeaderContent(sLocationDetails));
  let footerContentHtml = ReactDOMServer.renderToString(getFooterContent(sLocationDetails));


  let tooltipHtml = `
    <div class="stationTooltip">
      
      <div class="tooltip-header">
        ${headerContentHtml}
      </div>
      
      <hr class="tooltip-header-hr" />
      
      
      <div class="tooltip-body">${tooltipBodyContent}</div>
      
      
      <hr class="tooltip-footer-hr" />
      
      <div class="tooltip-footer">
        ${footerContentHtml}        
      </div>
      
    </div>`;

  return tooltipHtml;
};


/**
 * @param {string} name
 * @param {string} value
 * @param {string | null} iconClass
 */
let createDataLine = (name, value, iconClass) => {

  if (!iconClass) {
    iconClass = null;
  }

  return `
      <div class="tooltip-data-line">
        <span class="tooltip-data-line-icon pl ${iconClass}"></span>
        <span class="tooltip-data-line-value">${value}</span>
        <span class="tooltip-data-line-label">${name}</span>
      </div>`;
}


/**
 * @param {any} sLocationDetails
 */
let getLocationIconClass = (sLocationDetails) => {
  let isSection = sLocationDetails.section;
  if (isSection) {
    return `pl pl-section-sm`;
  }
  let isStation = sLocationDetails.station;
  if (isStation) {
    return `pl location-icon pl pl-station-icon`;
  }
  return `pl pl-icon pl-location-icon-blue`;
}


/**
 * @param {any} sLocationDetails
 */
let getLocationAlertIconClass = (sLocationDetails) => {
  let alertSeverity = sLocationDetails.alertSeverity;
  if (alertSeverity === 'WARNING') {
    return `pl alert-icon pl-warning-icon`;
  }
  if (alertSeverity === 'ERROR') {
    return `pl alert-icon pl-error-icon`;
  }
  return ``;
}


/**
 * @param {any} assetType 
 * @returns {JSX.Element | null}
 */
let getAssetAndIcon = (assetType) => {
  if (!assetType) {
    return null;
  }
  let assetIcon = assetType ? AssetHelper.getAssetIconComponent(assetType) : '';
  return (
    <div className="asset-with-icon">
      {assetIcon}
      <span className={'asset-type'}>{assetType}</span>
    </div>
  )

}


/**
 * 
 * @param {any} item 
 * @returns {JSX.Element}
 */
let getFooterContent = (item) => {

  let activityData = ActivityTypeHelper.GetActivityTypeDetails(item.activityType, item.activityTypeDisplayKey);
  let assetType = item.assetTypeDisplayKey ? assetTypeLabels.get(item.assetTypeDisplayKey) : '';

  return (
    <>
      <div className="activity-type">
        <span className={'icon ' + activityData.icon}> </span>
        <Label className="activity-inline-left" text={activityData.description} />
      </div>
      <div className="second-row">
        <Label className="activity-inline-left" text={item.m_ActivityTime} />
        {/* <Label className="activity-inline-left" text={'23/08/2017 16:49'} /> */}
        {getAssetAndIcon(assetType)}
      </div>

    </>
  );
};

/**
 * 
 * @param {any} item 
 * @returns {JSX.Element}
 */
let getHeaderContent = (item) => {

  let locationType = navigationStates.LOCATION;
  if (item.station) {
    locationType = navigationStates.STATION;
  }


  
  // Sections should not have a link to the location details page.
  if (item.section) {
    return (
      <>
        <i className={"tooltip-header-icon" + ' ' + getLocationIconClass(item)}></i>
        <span className="tooltip-header-title">{item.m_name}</span>
        <i className={"tooltip-header-alert-icon" + ' ' + getLocationAlertIconClass(item)}></i>
      </>
    );
  }

  
  return (
    <>
      <i className={"tooltip-header-icon" + ' ' + getLocationIconClass(item)}></i>
      <Link className="tooltip-header-title" label={item.m_name} id={item.id} type={locationType} />
      <i className={"tooltip-header-alert-icon" + ' ' + getLocationAlertIconClass(item)}></i>
    </>
  );
  
};




